<template>
    <span  :class="classes" :style="style">
      {{ statusLabel }}
    </span>
</template>

<script setup>
import { computed } from 'vue';
import './badge.css';

const props = defineProps({
  status: {
    type: String,
    validator: function (value) {
      // 'attached', 'relieved', 'terminated', 'detached', 'deactivated', 'pending'
      return ['draft', 'active', 'retired', 'inactive', 'archived', 'pending', 'relieved', 'terminated', 'detached'].indexOf(value) !== -1;
    },
  },
  backgroundColor: {
    type: String,
  },
  archived: {
    type: Boolean,
    default: false,
  }
});

const classes = computed(() => {
  if (props.status === "archived" || props.archived) {
    return 'archive-badge';
  }
  return {
    'storybook-badge': true,
    [`storybook-badge--${props.status}`]: true,
  };
});

const style = computed(() => {
  if (props.status === "archived" || props.archived) {
    return null;
  }
  return {
    backgroundColor: props.backgroundColor
  };
});

const statusLabel = computed(() => {
  return (props.status === 'archived' || props.archived) ? 'Archived' : props.status;
});

</script>
